import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M103.566 72.599a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M76.226 19.516a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M9.415 49.665a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M26.725 92.443a1.5 1.5 0 0 1 0 2.122l-9.994 9.994a1.501 1.501 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M14.61 92.443a1.5 1.5 0 0 1 2.12 0l9.995 9.994a1.5 1.5 0 0 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.122M105.633 39.339a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V40.839a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M97.066 47.905a1.5 1.5 0 0 1 1.5-1.5H112.7a1.5 1.5 0 0 1 0 3H98.566a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M83.659 24.764H36.805a4.59 4.59 0 0 0-4.591 4.59v57.644a4.59 4.59 0 0 0 4.59 4.59H83.66a4.59 4.59 0 0 0 4.59-4.59V29.355a4.59 4.59 0 0 0-4.59-4.591"
    />
    <path
      fill="#0597A3"
      d="M26.655 34.495h5.559v6.847h-5.56a3.425 3.425 0 0 1-3.422-3.423 3.426 3.426 0 0 1 3.423-3.424M26.655 48h5.559v6.847h-5.56a3.425 3.425 0 0 1-3.422-3.423A3.426 3.426 0 0 1 26.655 48M26.655 61.506h5.559v6.847h-5.56a3.425 3.425 0 0 1-3.422-3.423 3.425 3.425 0 0 1 3.423-3.423zM26.655 75.01h5.559v6.848h-5.56a3.425 3.425 0 0 1-3.422-3.423 3.426 3.426 0 0 1 3.423-3.424"
    />
    <path
      fill="#D8FFFF"
      d="M60.081 60.012c5.673 0 10.271-4.599 10.271-10.271S65.754 39.47 60.082 39.47c-5.674 0-10.272 4.598-10.272 10.27 0 5.673 4.598 10.272 10.271 10.272"
    />
    <path
      fill="#D8FFFF"
      d="M75.025 71.026c.637-.003 1.023-.681.73-1.246-2.889-5.557-8.847-9.77-15.471-9.77-6.925 0-12.892 4.103-15.603 10.01-.25.545.179 1.163.778 1.16z"
    />
  </svg>
);
const SvgEnrichedIconCustomerContactsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCustomerContactsBrand);
export default Memo;
